import { useTranslation } from "react-i18next";

import { BaseWindowHeader } from "components/window/BaseWindowHeader";

interface SettingsWindowHeaderProps {
    onClose?: () => void;
}

export function SettingsWindowHeader({ onClose }: SettingsWindowHeaderProps) {
    const { t } = useTranslation();

    return <BaseWindowHeader title={t("settings")} onClose={onClose} noBorder />;
}
